<template>
  <span>
    <feather-icon
      v-b-tooltip.hover.top="
        $t(
          `Global.${
            $can($acl.action.Update, $acl.subjects.Sorts)
              ? 'EditSubject'
              : 'ViewSubject'
          }`,
          { subject: $t('Management.Sorts.Sorts') },
        )
      "
      :icon="
        $can($acl.action.Create, $acl.subjects.Sorts) ? 'Edit2Icon' : 'EyeIcon'
      "
      size="16"
      class="hover-primary"
      @click="openSideBar"
    />
    <Form
      ref="form"
      :sort="updatedData"
      :submit-btn-text="`${$t('Global.Save')} ${$t('Management.Sorts.Sorts')}`"
      :can="$can($acl.action.Create, $acl.subjects.Sorts)"
      :header="$t('Management.Sorts.Sorts') + ' ' + $tc('Global.EditSubject')"
      @submit="submit"
    />
  </span>
</template>

<script>
import Form from './form.vue'

export default {
  components: {
    Form,
  },

  props: {
    sort: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    updatedData: null,
  }),

  methods: {
    openSideBar() {
      this.updatedData = { ...this.sort }
      this.$refs.form.sidebarVisible = true
    },
    async submit() {
      try {
        const { data } = await this.$axios.patch(
          `sorts/${this.sort.id}`,
          this.updatedData,
        )

        this.$alert.update(data.name)

        Object.keys(this.updatedData).forEach(key => {
          this.sort[key] = this.updatedData[key]
        })

        const { form } = this.$refs
        form.dirty = false
        form.sidebarVisible = false
      } catch {
        this.$alert.error()
      }
    },
  },
}
</script>
